// Injects a raw HTML/script snippet into the live DOM.
// Scripts inserted via innerHTML do NOT execute in browsers, so any <script> tags
// found in the snippet are re-created via document.createElement to guarantee execution.
//
// This is admin-only, intentional third-party script injection (GA4/GTM/etc — see
// PRD "Tracking Manager"), so we cannot strip <script> content outright. As defense
// in depth against DOM-based XSS smuggled through non-script tags (e.g. an
// <img onerror="..."> in a pasted snippet), any inline event-handler attributes
// (onerror, onload, ...) and javascript: URIs are stripped before the node is
// attached to the live document.
function stripDangerousAttributes(node) {
  if (node.nodeType !== 1) return;
  Array.from(node.attributes).forEach((attr) => {
    const name = attr.name.toLowerCase();
    const value = attr.value.trim().toLowerCase();
    if (name.startsWith("on") || value.startsWith("javascript:")) {
      node.removeAttribute(attr.name);
    }
  });
  Array.from(node.children).forEach(stripDangerousAttributes);
}

export function injectRawHtml(html, target = document.head) {
  if (!html) return;
  // DOMParser.parseFromString never executes embedded <script> tags or event-handler
  // attributes while parsing (it produces an inert Document, not a live one attached to
  // the page) - this is the standards-sanctioned way to turn an HTML string into DOM
  // nodes without ever going through a live-document innerHTML assignment.
  // Bare <script>/<noscript> snippets (the common case for GTM/GA4 codes) get parsed by
  // the browser into <head>, not <body>, per HTML5 parsing rules - so both are walked.
  const parsed = new DOMParser().parseFromString(html, "text/html");
  const nodes = [...parsed.head.childNodes, ...parsed.body.childNodes];
  nodes.forEach((node) => {
    if (node.nodeType === 1 && node.tagName === "SCRIPT") {
      const script = document.createElement("script");
      Array.from(node.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
      script.textContent = node.textContent;
      target.appendChild(script);
    } else {
      const clone = node.cloneNode(true);
      stripDangerousAttributes(clone);
      target.appendChild(clone);
    }
  });
}
